var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlusM(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 2.10059L13.4142 3.5148L12 4.92901L10.5858 3.5148L12 2.10059ZM12 7.75744L10.5858 6.34323L12 4.92901L13.4142 6.34323L12 7.75744ZM12 10.5859L10.5858 9.17165L12 7.75744L13.4142 9.17165L12 10.5859ZM13.4142 12.0001L12 10.5859L10.5858 12.0001L9.17157 10.5859L7.75736 12.0001L6.34315 10.5859L4.92893 12.0001L3.51472 10.5859L2.10051 12.0001L3.51472 13.4143L4.92893 12.0001L6.34315 13.4143L7.75736 12.0001L9.17157 13.4143L10.5858 12.0001L12 13.4143L10.5858 14.8285L12 16.2427L10.5858 17.6569L12 19.0711L10.5858 20.4854L12 21.8996L13.4142 20.4854L12 19.0711L13.4142 17.6569L12 16.2427L13.4142 14.8285L12 13.4143L13.4142 12.0001ZM16.2426 12.0001L14.8284 13.4143L13.4142 12.0001L14.8284 10.5859L16.2426 12.0001ZM19.0711 12.0001L17.6569 13.4143L16.2426 12.0001L17.6569 10.5859L19.0711 12.0001ZM19.0711 12.0001L20.4853 10.5859L21.8995 12.0001L20.4853 13.4143L19.0711 12.0001Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusM);
export default __webpack_public_path__ + "static/media/plus-m.9bb77158888acfd23f747b423165f743.svg";
export { ForwardRef as ReactComponent };